import React from 'react';
import { Button, type ButtonProps } from '../button/button';

export type IconButtonProps = Exclude<
  ButtonProps,
  'buttonType' | 'trailing' | 'leading'
>;

const IconButton = React.forwardRef<
  React.ElementRef<'button'>,
  IconButtonProps
>(({ ...props }, ref) => {
  return <Button buttonType="icon" ref={ref} {...props} />;
});

/**
 * Icon button component. Wrapper around the Button component with buttonType set to 'icon'.
 * Composed of:
 * `<IconButton.Icon>` to add an icon to the button. If loading, the icon will be replaced with a spinner.
 * `<IconButton.Spinner>` to add a spinner to the button. If loading, the spinner will be displayed.
 *
 * @link https://prod.web-components.srv.smart.com/?path=/docs/components-icon-button--docs
 */
const IconButtonNamespace = Object.assign(IconButton, {
  Spinner: Button.Spinner,
  Icon: Button.Icon,
});

export { IconButtonNamespace as IconButton };

IconButton.displayName = 'IconButton';
